const getApiUrl = () => {
  const serverURL =
    process.env.NODE_ENV === 'development'
      ? 'http://192.168.10.121:7071/api'
      : process.env.REACT_APP_API_URL
  return serverURL
}

export default getApiUrl
